exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".fct-horizontal-layout{display:-ms-flexbox;display:flex;-ms-flex-direction:row;flex-direction:row;-ms-flex-pack:start;justify-content:flex-start;-ms-flex-align:start;align-items:flex-start;-ms-flex-wrap:nowrap;flex-wrap:nowrap}.fct-horizontal-layout._stretch{-ms-flex-align:stretch;align-items:stretch}.fct-horizontal-layout._middle{-ms-flex-align:center;align-items:center}.fct-horizontal-layout._bottom{-ms-flex-align:end;align-items:flex-end}.fct-horizontal-layout>*{position:relative;-ms-flex-negative:0;flex-shrink:0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/less-loader!./layout/HorizontalLayout.less
// module id = 165
// module chunks = 0